import React, { useMemo } from 'react'

import { getFieldIcon } from 'features/admin/fields/icons/utils'

import { ItemSelector } from 'ui/components/ItemSelector'
import { ItemSelectorItem } from 'ui/components/ItemSelector/types'

type LayoutEditorFieldSelectorProps = {
    fields: FieldDto[]
    value: string[]
    onChange: (value: string[]) => void
    maxLabelLength?: number
    maxSelectedItems?: number
}

export const LayoutEditorFieldSelector: React.FC<LayoutEditorFieldSelectorProps> = ({
    fields,
    value,
    onChange,
    maxLabelLength,
    maxSelectedItems,
}) => {
    const fieldOptions: ItemSelectorItem[] = useMemo(() => {
        return fields.map((field) => {
            const fieldIcon = getFieldIcon(field)

            return {
                label: field.label,
                value: field._sid,
                icon: fieldIcon?.type === 'lucide' ? fieldIcon : undefined,
            }
        }, [])
    }, [fields])

    return (
        <ItemSelector
            items={fieldOptions}
            value={value}
            onChange={onChange}
            maxLabelLength={maxLabelLength}
            maxSelectedItems={maxSelectedItems}
        />
    )
}
